import { Box } from "../../../components/elements"
import {
  Checkbox,
  CheckboxGroup,
  Fieldset,
  Input,
  Label,
  Question,
  validations,
} from "../../../components/form"

import { useFormContext } from "react-hook-form"
import { IHRQuestionValues, IQuestionValues, IScopeOfWorkValue } from "../types"

const SCOPE_OF_WORK_MAP: { label: string; value: IScopeOfWorkValue }[] = [
  { label: "デバイスの購入代行・キッティング", value: "kitting" },
  { label: "デバイスの回収・保管・廃棄/下取り", value: "storage" },
  { label: "デバイスの初期化/クリーニング", value: "initialize" },
  { label: "SaaSのアカウント発行", value: "provisioning" },
  { label: "SaaSのアカウント停止/削除", value: "deprovisioning" },
  { label: "SaaSのアカウント設定変更", value: "account_update" },
]

const HR_FIELDS: {
  label: string
  name: keyof IHRQuestionValues
}[] = [
  {
    label: "入社",
    name: "num_joins",
  },
  {
    label: "退職",
    name: "num_leaves",
  },
  {
    label: "異動",
    name: "num_transfers",
  },
]

const QuestionFields = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<IQuestionValues>()

  return (
    <Box gapInRem={3} flexDirection={`column`} fullwidth>
      <Fieldset>
        <Question
          multiselect
          number={1}
          text="アウトソーシングを希望される業務はなんですか?"
        />

        <CheckboxGroup error={errors["scope_of_work"]}>
          {SCOPE_OF_WORK_MAP.map((item) => (
            <Checkbox
              key={item.value}
              label={item.label}
              registration={register(
                "scope_of_work",
                validations.requiredCheckboxGroup
              )}
              value={item.value}
            />
          ))}
        </CheckboxGroup>
      </Fieldset>

      <Fieldset>
        <Question
          number={2}
          text="毎月の入社数、退職数、異動数はいくつですか?"
        />

        {HR_FIELDS.map((field) => (
          <Fieldset key={field.name}>
            <Label>{field.label}</Label>
            <Input
              error={errors[field.name]}
              min={0}
              placeholder="例) 100"
              registration={register(
                field.name,
                validations.requiredNonNegativeNumber
              )}
              short
              type="number"
              unit="人"
            />
          </Fieldset>
        ))}
      </Fieldset>

      <Fieldset>
        <Question number={3} text="社内でご利用中の SaaS はいくつですか?" />
        <Input
          error={errors[`num_apps`]}
          min={0}
          placeholder="例) 10"
          registration={register(
            "num_apps",
            validations.requiredNonNegativeNumber
          )}
          short
          type="number"
          unit="個"
        />
      </Fieldset>
    </Box>
  )
}

export {
  QuestionFields,
  SCOPE_OF_WORK_MAP,
  type IQuestionValues,
  type IScopeOfWorkValue,
}
